import { forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import styled from 'styled-components';
import { H3, Pmb } from './Typography';
import theme from '../common/theme';

const Input = styled(PhoneInput)`
    flex: 1;
    outline: none;
    padding: 1rem;
    font-size: 1rem;
    background: ${theme.palette.light};
    border: 1px solid ${theme.palette.light};
    margin-top: 0.5rem;

    &::placeholder {
        font-family: "Roboto Condensed";
        color: ${theme.palette.dark};
        font-size: 14px;
    }
`

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 1rem 0;
`

const UncontrolledFormPhoneNumber = forwardRef(({ input, label, ...props }, ref) => (
    <Container>
        <Pmb>{label}</Pmb>
        <Input
            defaultCountry="CA"
            ref={ref}
            {...props}
            {...input}
        />
    </Container>
))

const FormPhoneNumber = ({ name, control, rules, ...rest }) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={{
                ...rules,
            }}
            render={({ field: { ...fieldProps } }) => (
                <UncontrolledFormPhoneNumber {...fieldProps} {...rest} />
            )}
        />
    );
};

export default FormPhoneNumber;